import ExcelImport from "./utils/ExcelImport";

export default function ImportPage() {
  return <ExcelImport />;
}
